<template>
  <v-flex>
    <v-data-table
      v-model="vatMethods"
      :loading="loading"
      :headers="headers"
      :items="shippingMethods"
      :rows-per-page-text="$t('Rows per page')"
      :pagination.sync="pagination"
      :total-items="total"
      show-select
      select-all
      class="elevation-1"
      item-key="id"
    >
      <v-progress-linear
        slot="progress"
        color="primary"
        indeterminate
      />

      <template v-slot:items="props">
        <settings-vat-method-row
          :props="props"
        />
      </template>
      <template v-slot:pageText="props">
        <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import SettingsService from '@/modules/Settings/service.js'
import SettingsVatMethodRow from '@/modules/Settings/components/Taxes/SettingsVatMethodRow'

export default {
  name: 'SettingsVatShippings',
  components: { SettingsVatMethodRow },
  props: {
    vat: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'created_at'
      },
      total: 0,
      loading: false,
      shippingMethods: []
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Name'), value: 'name' }
      ]
    },
    vatMethods: {
      get: function () {
        return this.shippingMethods.filter(shipping => this.vat.shipping_ids.includes(shipping.id))
      },
      set: function (methods) {
        this.vat.shipping_ids = methods.map(method => method.id)
      }
    }
  },

  watch: {
    pagination: function () {
      this.getShippingMethods()
    }
  },

  methods: {
    async getShippingMethods () {
      this.loading = true
      const res = await SettingsService.loadShippingMethods(this.pagination)
      this.shippingMethods = res.collection
      this.total = res.page.total
      this.loading = false
    }
  }
}
</script>
